/**
 * Cives Hub Backend Authentication API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Modalita\' della riga di confine di graduatoria
 */
export enum RigaConfineModalita {

    ASSEGNA_RESIDUO = 'ASSEGNA_RESIDUO',

    SOLO_IMPORTO_PIENO = 'SOLO_IMPORTO_PIENO'
}

